import * as React from 'react';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  FormControl,
  CircularProgress
} from '@mui/material';
import api from "../services/api";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { pt } from 'yup-locale-pt';
import {
  TextField
} from './';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { errorMessages } from '../config';

require('../services/email-list-validation.js');

yup.setLocale(pt);


const DialogoAutorizaUsuarios = ({ title, gestao, open, onClose }) => {

  let loading = useStoreState((state) => state.nav.loading);
  let startLoading = useStoreActions((actions) => actions.nav.startLoading);
  let stopLoading = useStoreActions((actions) => actions.nav.stopLoading);

  const schema = yup.object({
    users: yup.array().emailList()
      .min(1,({label})=>`${label} deve ter pelo menos 1 item`)
      .label('Usuários')
  }).required();

  const useFormRef = useForm({
    mode: 'onTouched',
    resolver: yupResolver(schema)
  });


  const { handleSubmit, reset,
          formState: {isDirty,isSubmitting} } = useFormRef;

  const onSave = async (data) => {
    startLoading();
    try {
      let postUsers = (await api.http.post('/gestores',{
        ...data,
        gestao: gestao
      })).data;

      if(postUsers.errors.length==0) {
        stopLoading({ severity: 'success' });
        close(true);
      } else {
        let sucessos = '';
        if(postUsers.success.length>0) {
          sucessos = postUsers.success
            .map((user)=>user.email)
            .join(',');
        };

        let erros = postUsers.errors
          .map((error)=>error.user+' ('+
               ((error.error in errorMessages)?errorMessages[error.error]:
                error.error)+')').join(', ');

        let message;
        if(postUsers.success.length>0) {
          message = (
            <React.Fragment><b>Aviso</b><br/>
              Sucessos: {sucessos}<br/>
              Erros: {erros}
            </React.Fragment>
          );
        } else {
          message = (
            <React.Fragment><b>Erro</b><br/>
              {erros}
            </React.Fragment>
          );
        }
        stopLoading({
          severity: postUsers.success.length>0?'warning':'error',
          message: message,
          autoHideDuration: null
        });
        reset({
          users: postUsers.errors.map((error)=>error.user).join('\r\n')
        });
      }

    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
      throw error;
    };
  };

  const close = (reload=false) => {
    reset({
      users: ''
    });
    onClose(reload);
  };

  return (
    <Dialog open={open} onClose={()=>close()}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Adicione os e-mails dos usuários que deseja autorizar
          (um por linha, separados por vírgula ou espaço)
        </DialogContentText>
        <FormControl sx={{ my: 2 }} fullWidth>

          <TextField
            autoFocus
            margin="dense"
            fullWidth
            field="users"
            multiline rows={4}
            schema={schema} useFormRef={useFormRef} />
        </FormControl>
      </DialogContent>
      <DialogActions>
        { loading>0 &&
          <CircularProgress
            size={30}
            sx={{'position': 'absolute', 'left':25, 'bottom': 12}} /> }
        <Button color="inherit" onClick={()=>close()}>
          CANCELAR
        </Button>
        <Button color="primary"
                onClick={handleSubmit(onSave)}
                disabled={!isDirty || isSubmitting}>
          SALVAR
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogoAutorizaUsuarios;
